<template>
  <v-app id="keep">
    <!-- <template>
      <sign-in-dialog :showSignInDialog="showSignInDialog"/>
    </template> -->
    <v-app-bar
      height="50"
      app
      clipped-left
    >
      <v-app-bar-nav-icon
        v-if="userIsAuthenticated && (user.role === 'mega_administrator' || (companyId !== '' && companyStatus === 'active'))"
        @click.stop="drawer = !drawer"
        style="color:#606060"
      />
      <v-toolbar-title style="color:#fff">
        <v-row  >
          <v-col>
            <router-link to="/" tag="div" style="cursor:pointer">
              <span class="title ml-3 mr-5">
                <img
                  :src="adarizLogo"
                  alt="Adariz"
                  height="30"
                >
              </span>
            </router-link>
          </v-col>
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <h1 class="font-weight-light caption" v-if=" user && user.role === 'mega_administrator'">{{toolbarCompanyName}}</h1>
        <h1 class="font-weight-light caption" v-else>{{companyName}}</h1>
      </v-toolbar-title>
      <v-toolbar-items>
        <v-tooltip
          bottom
          v-if="userIsAuthenticated"
        >
          <template v-slot:activator="{on}">
            <v-btn
              text
              class="font-weight-light caption pr-0 pl-0 mr-0"
              v-on="on"
              light
              @click="onLogout">
              <v-avatar
                v-if="companyPhotoUrl !== ''"
                size="36px"
              >
                <img
                  :src="companyPhotoUrl"
                  alt="company avatar"
                >
              </v-avatar>
              <v-icon v-else color="#606060">mdi-exit-to-app</v-icon>
            </v-btn>
          </template>
          <span>Salir</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      v-if="userIsAuthenticated"
      app
      clipped
      temporary
      width="300"
    >
    <v-row align="center" v-if="user.role === 'administrator'">
      <v-col cols="3" class="pl-8">
        <v-avatar
          v-if="companyPhotoUrl !== ''"
          size="36px"
        >
          <img
            :src="companyPhotoUrl"
            alt="company avatar"
          >
        </v-avatar>
      </v-col>
      <v-col cols="9" class="pr-5">
        <v-select
          flat
          :items="selectCompanies"
          v-model="choosenCompany"
          @change="setCompany"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-else-if="companyId !== ''">
      <v-col cols="3" class="pl-8">
        <v-avatar
          v-if="companyPhotoUrl !== ''"
          size="36px"
        >
          <img
            :src="companyPhotoUrl"
            alt="company avatar"
          >
        </v-avatar>
      </v-col>
      <v-col cols="9" class="pr-5">
        <h4>{{companyName}}</h4>
      </v-col>
    </v-row>
      <v-list
        v-for="(item, i) in drawerItems"
        :key="i"
        dense
        rounded
      >
          <v-divider
            v-if="item.divider"
            dark
          ></v-divider>
          <v-list-group
            v-else-if="item.nestedItems"
            :prepend-icon="item.icon"
            value="true"
            no-action
          >
            <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{item.text}}</v-list-item-title>
                </v-list-item-content>
            </template>
            <v-list-item
              v-for="(nestedItem, j) in item.nestedItems"
              :key="j"
              :to="nestedItem.link"
              link
            >
              <v-list-item-action>
                <v-icon :style="`color:${menuColor}`">{{nestedItem.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="grey--text font-weight-light body-2">
                  {{nestedItem.text}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="i"
            :to="item.link"
            link
          >
            <v-list-item-action>
              <v-icon :style="`color:${menuColor}`">{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text font-weight-light body-2">
                {{item.text}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <main class="myStyle">
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
/* eslint-disable no-console */
import * as constants from '../constants.json'

export default {
  data () {
    return {
      drawer: null,
      mini: true,
      toolbar: false,
      companies: [],
      companyId: '',
      companyPhotoUrl: '',
      companyName: '',
      choosenCompany: '',
      companyStatus: '',
      selectCompanies: [],
      showSignInDialog: { show: false },
      adarizLogo: constants.ADARIZ_LOGO_URL,
      textColor: '#00e2a4',
      menuColor: '#606060'
    }
  },

  computed: {
    drawerItems () {
      let items = []
      const user = this.$store.getters.getUser
      const newToolbar = this.$store.getters.getNewToolbar
      console.log('newToolbar', newToolbar)
      switch (true) {
        case user.role === 'mega_administrator' || user.role === 'super_administrator':
          if (newToolbar) {
            items = [
              { icon: 'mdi-android-debug-bridge', text: 'Bots', link: '/bots' },
              { divider: true },
              { icon: '',
                text: this.$store.getters.getCompanyData.companyName,
                nestedItems: [
                  { icon: 'mdi-tshirt-crew', text: 'Productos', link: '/products' },
                  { icon: 'mdi-shape', text: 'Categorías', link: '/categories' },
                  { icon: 'mdi-database-plus', text: 'Base de información', link: '/company/companydata/edit' },
                  { icon: 'mdi-cart-arrow-down', text: 'Órdenes', link: '/orders' },
                  { icon: 'mdi-account-group', text: 'Colaboradores', link: '/collaborators' }
                ] }
            ]
          } else {
            items = [
              { icon: 'mdi-android-debug-bridge', text: 'Bots', link: '/bots' }
            ]
          }
          break
        case user.role === 'administrator':
          items = [
            { icon: 'mdi-tshirt-crew', text: 'Productos', link: '/products' },
            { icon: 'mdi-shape', text: 'Categorías', link: '/categories' },
            { icon: 'mdi-database-plus', text: 'Base de información', link: '/company/companydata/edit' },
            { icon: 'mdi-cart-arrow-down', text: 'Órdenes', link: '/orders' },
            { icon: 'mdi-account-group', text: 'Colaboradores', link: '/collaborators' }
          ]
          break
        case user.role === 'editor':
          if (user.companyId !== '') {
            items = [
              { icon: 'mdi-tshirt-crew', text: 'Productos', link: '/products' },
              { icon: 'mdi-shape', text: 'Categorías', link: '/categories' },
              { icon: 'mdi-database-plus', text: 'Base de información', link: '/company/companydata/edit' },
              { icon: 'mdi-cart-arrow-down', text: 'Órdenes', link: '/orders' }
            ]
          }
      }

      return items
    },

    toolbarCompanyName () {
      console.log(this.$store.getters.getCompanyData.companyName)
      return this.$store.getters.getCompanyData.companyName
    },

    newToolbar () {
      return this.$store.getters.getNewToolbar
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    },

    user () {
      return this.$store.getters.getUser
    }
  },

  watch: {
    '$route': {
      handler: (to, from) => {
        document.title = to.meta.title || 'Adariz - Experto Virtual en Ventas'
      },
      immediate: true
    },

    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      // eslint-disable-next-line
      console.log('value', value)
      if (value === null || value === undefined) {
        this.$router.push('/')
      } else {
        if (value.role === 'administrator') {
          for (const company of value.companies) {
            this.selectCompanies.push(company.name)
            this.companies.push(company)
          }

          this.companyId = localStorage.companyId
          this.companyName = localStorage.companyName
          this.choosenCompany = localStorage.companyName
          this.companyPhotoUrl = localStorage.companyPhotoUrl
          this.companyStatus = this.$store.getters.getCompanyData.companyStatus
        } else if (value.role === 'editor' && value.companyId !== '') {
          console.log({ value })
          this.companyId = localStorage.companyId
          this.companyName = localStorage.companyName
          this.choosenCompany = localStorage.companyName
          this.companyPhotoUrl = localStorage.companyPhotoUrl
          this.companyStatus = this.$store.getters.getCompanyData.companyStatus
        }
      }
    }
  },

  methods: {
    async onSignIn () {
      this.$store.dispatch('actionFacebookLogin')
      // this.showSignInDialog.show = true
    },

    async onLogout () {
      this.companyId = ''
      this.companyName = ''
      this.choosenCompany = ''
      this.companyPhotoUrl = ''
      this.companyStatus = ''
      this.$store.dispatch('actionLogout')
    },

    setCompany () {
      const companyData = this.companies.find(company => company.name === this.choosenCompany)
      localStorage.companyId = companyData.id
      localStorage.companyName = companyData.name
      localStorage.companyPhotoUrl = companyData.photoUrl

      this.$store.dispatch('actionLoadCompany', companyData.id)

      this.companyName = companyData.name
      this.companyPhotoUrl = companyData.photoUrl

      this.$router.push('/')
    }
  }
}
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none
}

.myStyle {
  background: #f9f9f9;
}
</style>
